import "aos/dist/aos.css";
import React, { useEffect, useState } from "react";
import { RiWhatsappFill } from "react-icons/ri";
import { connect } from "react-redux";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";
import { bindActionCreators } from "redux";
import Routes from "./routes";
import "./style.css";

function App() {
	let [path, setPath] = useState("")
	useEffect(() => {
		setPath(window.location.pathname.split("/")[1])
	}, [window.location.pathname])
	console.log(window.location.pathname.split("/")[1])
	return (
		<div className={path === "Certificate" ? "" : "App"}>
			{path !== "Certificate" ?
				<ReactWhatsapp number="+92 324 4425299" message="" className="whatsapp_float">
					<RiWhatsappFill className="whatsapp-icon" />
				</ReactWhatsapp>
				: null}
			<Router>
				<Switch>

					<Routes />
				</Switch>
			</Router>
		</div>
	);
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);
